import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import SoftBadge from 'components/common/SoftBadge';

/**
 * New 아이콘
 * @summary 최근 3주일 게시글 New 아이콘 장착
 */
const New = ({ regDt }) => (
  <>
    {moment().diff(regDt, 'weeks', true) <= 3 && (
      <SoftBadge bg="primary" className="me-1">
        N
      </SoftBadge>
    )}
  </>
);

New.propTypes = {
  // 등록일
  regDt: PropTypes.string.isRequired
};

export default New;
